import { HostSDK } from '@/sdks/host';

if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).PGGameSDK = HostSDK;
}
